import { Vehicle } from "../../common/models/Vehicle";
import { VehicleResponse } from "../models/responses/VehicleResponse";
import { VehicleTypeMapper } from "./VehicleTypeMapper";

export const VehicleMapper = (data: VehicleResponse): Vehicle => {
  return {
    id: data._id,
    color: data.color,
    mark: data.mark,
    model: data.model,
    plate: data.plate,
    vehicleType: VehicleTypeMapper(data.vehicleType)
  }
}